const protectedPages: string[] = [
  '/my-courses',
  '/settings',
  '/study-course/*',
  '/create-course/*',
  '/author',
  '/author/verification',
  '/personal-info',
  '/account',
  '/author-profile-settings',
  '/student',
]

export const isProtected = (route: string) => {
  return protectedPages.some((protectedRoute: string) => {
    const regex = new RegExp('^' + protectedRoute.replace(/\*/g, '.*') + '$')
    return regex.test(route)
  })
}

export default protectedPages
